import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { VersionControlService, CourseVersion } from '@scaffold/services/version-control.service'
import { Subscription } from 'rxjs';
import { trigger, state, transition, animate, style, keyframes } from '@angular/animations';
import { Router } from '@angular/router';
import { ItemsService } from '@scaffold/services/items.service';


@Component({
  selector: 'app-version-control',
  templateUrl: './version-control.component.html',
  styleUrls: ['./version-control.component.scss'],
  animations: [
    trigger('input', [
      state('in', style({ height: 'auto' })),
      transition('void => *', [
        animate('.3s ease-in', keyframes([
          style({ opacity: 0, offset: 0 }),
          style({ opacity: 1, offset: 1 }),
        ]))
      ]),
      transition('* => void', [
        animate('0s ease-in', keyframes([
          style({ opacity: 1, offset: 0 }),
          style({ opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ]
})
export class VersionControlComponent implements OnInit, OnDestroy {
  private _id: number;
  current = {name:"Current"}
  @Output() updated = new EventEmitter<string>();
  @Input('id')
  set id(id: number) {
    this._id = id;
    if (this.versionSub)
      this.versionSub.unsubscribe();
    this.versionSub = this.versionService.getVersions(this.id, this.type).subscribe(v => {
      this.versions = v.versions;
      this.updated.emit();
    })
    // this.versionService.updateItem(id);
  }
  get id() {
    return this._id;
  }
  @Input() show_create: boolean = true;
  creating= false;
  @Input() type: string;
  versionSub: Subscription;
  versions: Array<CourseVersion>
  new_version: CourseVersion = new CourseVersion();
  constructor(public versionService: VersionControlService, private courseService: ItemsService, private router: Router) { }

  ngOnInit() {

  }

  ngOnDestroy() {
    if (this.versionSub)
      this.versionSub.unsubscribe();
  }

  createVersion(version: CourseVersion) {
    if (version.name && version.description) {
      this.versionService.createVersion(this.id, this.type, version).subscribe(created => {
        this.versions = [created, ...this.versions];
        this.new_version = created;
        this.updated.emit();
      });
      this.new_version = null;
      this.creating = false;
    }
  }

  setNewVersion(version?) {
    this.new_version = version || new CourseVersion();
    this.creating = true;
  }

  createFromVersion(version) {
    this.versionService.createFromVersion(this.id, this.type, version.id)
  }
}
